/*
 * GS cart drawer helpers:
 * 1. Shows "Added to the pack!" when the drawer opens because something was just added
 *    (Dawn product form or GS Quick Add), and "Your cart" when opened from the header.
 *    In the "just added" state only the added line is listed (the subtotal still covers the
 *    whole cart) so the checkout button stays on screen, like Sloth Hiking Club.
 * 2. Fills the "Complete the pack" upsell row with Shopify product recommendations for the
 *    most recently added item (T-shirts only, excluding anything already in the cart).
 * Dawn re-renders the drawer contents after every change, so the row is rebuilt each time
 * (recommendations are cached per product so this doesn't re-fetch).
 */
(function () {
  if (window.GSCartDrawer) return;

  var cache = {};
  var MAX_UPSELLS = 6;

  function drawerEl() {
    return document.querySelector('cart-drawer');
  }

  var justAddedVariant = null;

  function addedVariantId(event) {
    var id = event.productVariantId;
    var data = event.cartData || {};
    if (!id && data.variant_id) id = data.variant_id;
    if (!id && data.items && data.items.length) id = data.items[data.items.length - 1].variant_id;
    return id ? String(id) : null;
  }

  // Show only the line that was just added. If it can't be found (e.g. it was removed), show everything.
  function applyFocus() {
    var drawer = drawerEl();
    if (!drawer) return;
    var rows = drawer.querySelectorAll('.cart-item');
    var found = false;
    rows.forEach(function (row) {
      var input = row.querySelector('[data-quantity-variant-id]');
      var match = !!justAddedVariant && !!input && input.getAttribute('data-quantity-variant-id') === justAddedVariant;
      if (row.classList.contains('gs-is-added') !== match) row.classList.toggle('gs-is-added', match);
      if (match) found = true;
    });
    var focus = found && drawer.hasAttribute('data-gs-just-added');
    if (focus !== drawer.hasAttribute('data-gs-focus')) drawer.toggleAttribute('data-gs-focus', focus);
  }

  function markJustAdded(event) {
    if (!event || event.source !== 'product-form') return;
    var drawer = drawerEl();
    if (!drawer) return;
    drawer.setAttribute('data-gs-just-added', '');
    justAddedVariant = addedVariantId(event);
    applyFocus();
  }

  function watchClose(drawer) {
    new MutationObserver(function () {
      if (drawer.classList.contains('active')) return;
      // Wait for the slide-out animation before switching the heading back.
      setTimeout(function () {
        if (drawer.classList.contains('active')) return;
        drawer.removeAttribute('data-gs-just-added');
        drawer.removeAttribute('data-gs-focus');
        justAddedVariant = null;
      }, 400);
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function updateArrows(box) {
    var track = box.querySelector('.gs-cart-upsells__track');
    var prev = box.querySelector('[data-gs-upsell-prev]');
    var next = box.querySelector('[data-gs-upsell-next]');
    if (!track || !prev || !next) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max;
  }

  function fillUpsells(box, html) {
    if (!box.isConnected || box.hasAttribute('data-gs-filled')) return;
    box.setAttribute('data-gs-filled', '');
    var exclude = (box.getAttribute('data-exclude') || '').split(',');
    var doc = new DOMParser().parseFromString(html || '', 'text/html');
    var slides = Array.prototype.slice
      .call(doc.querySelectorAll('.gs-cart-upsells__slide'))
      .filter(function (slide) {
        return slide.querySelector('[data-gs-quick-add]') && exclude.indexOf(slide.getAttribute('data-product-id')) === -1;
      })
      .slice(0, MAX_UPSELLS);

    if (!slides.length) {
      box.hidden = true;
      return;
    }

    var track = box.querySelector('.gs-cart-upsells__track');
    track.innerHTML = '';
    slides.forEach(function (slide) {
      track.appendChild(document.importNode(slide, true));
    });
    box.hidden = false;
    track.addEventListener('scroll', function () {
      updateArrows(box);
    }, { passive: true });
    updateArrows(box);
  }

  function loadUpsells() {
    var box = document.getElementById('CartDrawer-Upsells');
    if (!box || box.hasAttribute('data-gs-requested')) return;
    box.setAttribute('data-gs-requested', '');

    var productId = box.getAttribute('data-product-id');
    var url = box.getAttribute('data-url');
    if (!productId || !url) {
      box.hidden = true;
      return;
    }

    if (!cache[productId]) {
      cache[productId] = fetch(url + '?product_id=' + encodeURIComponent(productId) + '&limit=10&section_id=gs-cart-upsells')
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .catch(function () {
          return '';
        });
    }
    cache[productId].then(function (html) {
      fillUpsells(box, html);
    });
  }

  function onClick(event) {
    var arrow = event.target.closest('[data-gs-upsell-prev], [data-gs-upsell-next]');
    if (!arrow) return;
    var box = arrow.closest('.gs-cart-upsells');
    var track = box && box.querySelector('.gs-cart-upsells__track');
    if (!track) return;
    var step = track.clientWidth * 0.9;
    track.scrollBy({ left: arrow.hasAttribute('data-gs-upsell-prev') ? -step : step, behavior: 'smooth' });
  }

  function init() {
    var drawer = drawerEl();
    if (!drawer) return;

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, markJustAdded);
    }
    watchClose(drawer);

    var pending = null;
    new MutationObserver(function () {
      if (drawer.hasAttribute('data-gs-just-added')) applyFocus();
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        applyFocus();
        loadUpsells();
      }, 50);
    }).observe(drawer, { childList: true, subtree: true });

    document.addEventListener('click', onClick);
    loadUpsells();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.GSCartDrawer = { loadUpsells: loadUpsells };
})();
